export const useInitialNavTabState = (arr) => {
    const initialState = {
        initialSelectedTab : null,
        initialContent : null,
    };

    const index = arr.findIndex((item) => item?.selected === true);

    if (index > -1) {
        initialState.initialSelectedTab = index;
    }

    if (arr[index].render) {
        initialState.initialContent = arr[index].render();
    }

    return initialState;
};
